import { Route } from "@angular/router";
import { MinhasTransferenciasPage } from "./minhas-transferencias.page";

export const MinhasTransferenciasRouter: Route[] = [
  { path: 'minhas-transferencias', component: MinhasTransferenciasPage }
];
